import { Navbar } from "components/Navbar";
import { Sidebar } from "components/Sidebar";
import { ErrorModal } from "components/modals/ErrorModal";
import { WalletModal } from "components/modals/WalletModal";
import { Outlet } from "react-router-dom";

export function LayoutPage() {
    return <div className="layout-wrapper layout-content-navbar">


        <div className="layout-container">

            <Sidebar />

            <div className="layout-page">

                <Navbar />

                <div className="content-wrapper">

                    <Outlet />

                    <div className="mb-5"></div>

                    <div className="content-backdrop fade"></div>
                    <WalletModal />

                    <button
                        id="modal-trigger"
                        type="button"
                        className="d-none"
                        data-bs-toggle="modal" />

                    <div className="modal fade" id="small-modal" tabIndex={-1} aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        </div>
                    </div>

                    <div className="modal fade" id="large-modal" tabIndex={-1} aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        </div>
                    </div>

                    <div className="toast-container position-fixed bottom-0 end-0"></div>
                </div>
            </div>
        </div >

        <div className="layout-overlay layout-menu-toggle"></div>
    </div >
}